<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit ${tripPlanningModule.regionRestriction}`
        : `Add ${tripPlanningModule.regionRestriction}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <SecondaryButton  
        id="regionRestrictionReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="regionRestrictionSubmit"
        @click="submitForm()"
        :disabled="!formValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="regionRestrictionForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-card elevation="0" class="pa-4 rounded-lg">
          <v-row class="ma-0">
            <v-col cols="4">
              <InputField
                id="name"
                v-model="regionRestrictionForm.name"
                label="Restriction Name"
                :required="true"
                name="name"
                :error-messages="formErrors.name"
                @input="delete formErrors.name"
              />
            </v-col>
            <v-col cols="8">
              <InputField
                id="description"
                v-model="regionRestrictionForm.description"
                label="Description"
                name="description"
                :error-messages="formErrors.description"
                @input="delete formErrors.description"
              />
            </v-col>
            <v-col cols="12">
              <span class="font-weight-bold text-body-1"
                >Draw Your Geofence</span
              >
            </v-col>
            <v-col cols="12">
              <GoogleMap
                mapId="regionRestrictionMap"
                mapWidth="100%"
                mapHeight="calc(100vh - 360px)"
                ref="regionRestrictionMap"
                :isDrawable="true"
                :hasMapInfo="true"
              >
                <template #mapInfo>
                  <MapInfo legendType="region_restriction" />
                </template>
              </GoogleMap>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import { tripPlanningModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseFormLayout,
    GoogleMap,
    MapInfo,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
  },
  data() {
    return {
      tripPlanningModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      regionRestrictionForm: {},
      formErrors: {},

      branchList: [],
    };
  },
  computed: {
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    formValid() {
      return (
        this.isValid && this.$refs?.regionRestrictionMap?.convertToGeoJSON()
      );
    },
  },
  methods: {
    resetForm() {
      this.regionRestrictionForm = {};
      this.$refs.regionRestrictionForm.reset();
      let inter = setInterval(() => {
        if (
          this.$refs.regionRestrictionMap &&
          this.$refs.regionRestrictionMap.map
        ) {
          clearInterval(inter);
          this.$refs.regionRestrictionMap.deleteShape();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(inter);
      }, 3000);
    },
    getRegionRestrictionObject(id) {
      bus.$emit("showLoader", true);
      this.$api.regionRestriction
        .getRegionRestrictionObject(id)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.regionRestrictionForm = res.data;
          this.loadEditablePolygon();
          this.getRemainingRegionRestrictionList({ exclude_zone: id });
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    loadEditablePolygon() {
      let path = [];
      this.regionRestrictionForm.geofence.coordinates[0].forEach((element) => {
        path.push({ lat: element[1], lng: element[0] });
      });

      let inter = setInterval(() => {
        if (
          this.$refs.regionRestrictionMap &&
          this.$refs.regionRestrictionMap.map
        ) {
          clearInterval(inter);
          this.$refs.regionRestrictionMap.setEditablePolygon(
            path,
            this.regionRestrictionForm.geofence.coordinates[0]
          );
        }
      });
    },
    submitForm() {
      if (!this.$refs.regionRestrictionForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      let data = { ...this.regionRestrictionForm };
      let geoJSON = this.$refs.regionRestrictionMap.convertToGeoJSON();
      if (!geoJSON) {
        bus.$emit("showToastMessage", {
          message: "Please Draw your geofence before submitting the form!",
          color: "error",
          hasActions: true,
        });
        bus.$emit("showLoader", false);
        return;
      }
      data.geofence = geoJSON.geometry;
      bus.$emit("showLoader", true);
      if (this.editMode) {
        this.$api.regionRestriction
          .updateRegionRestrictionObject({
            id: this.regionRestrictionForm.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Region Restriction information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      } else {
        data.branch = this.selectedBranch;
        this.$api.regionRestriction
          .createRegionRestrictionObject(data)
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Region Restriction created!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      }
    },
    async getRemainingRegionRestrictionList(params) {
      await this.$api.regionRestriction
        .getRemainingRegionRestrictionList(params)
        .then((res) => {
          let int = setInterval(() => {
            if (
              this.$refs.regionRestrictionMap &&
              this.$refs.regionRestrictionMap.map
            ) {
              clearInterval(int);
              this.$refs.regionRestrictionMap.clearGeoJson();
              let features = res.data.map((feature) => {
                return {
                  ...feature,
                  type: "Feature",
                };
              });
              this.$refs.regionRestrictionMap.addFeatures(features);
            }
          }, 200);
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          this.formErrors = err.data;
        });
    },
  },
  mounted() {
    if (!this.editMode) {
      this.getRemainingRegionRestrictionList();
    }
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.getRegionRestrictionObject(this.$route.params.id);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
